class ParentStateWatcher {
	constructor(parentEl, childSelector, classToAdd) {
		this.parent = parentEl;
		this.childSelector = childSelector;
		this.classToAdd = classToAdd;
		this.init();
	}

	init() {
		const child = this.parent.querySelector(this.childSelector);
		if (child) {
			this.parent.classList.add(this.classToAdd);
		}
	}
}

export default ParentStateWatcher;